import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=7232d2fc&scoped=true&"
import script from "./PolicyForm.vue?vue&type=script&lang=js&"
export * from "./PolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./PolicyForm.vue?vue&type=style&index=0&id=7232d2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7232d2fc",
  null
  
)

export default component.exports